import { NavLink } from "react-router-dom";
import { cn } from "@/lib/cn";
import { NAV_ITEMS } from "./navItems";

export function BottomNav() {
  return (
    <nav className="lg:hidden fixed bottom-0 inset-x-0 z-30 h-14 bg-bg-elevated border-t border-border flex">
      {NAV_ITEMS.map(({ to, label, icon: Icon }) => (
        <NavLink
          key={to}
          to={to}
          className={({ isActive }) =>
            cn(
              "flex-1 flex flex-col items-center justify-center gap-0.5 text-text-muted hover:text-text",
              isActive && "text-text",
            )
          }
        >
          <Icon className="size-4" />
          <span className="text-[11px] leading-none">{label}</span>
        </NavLink>
      ))}
    </nav>
  );
}
